<section class="w-full min-h-screen px-5 py-16 flex flex-col items-center justify-center gap-12">
  <div
    class="flex flex-col items-center max-w-[1500px] leading-10 sm:leading-14 md:leading-20 text-center justify-center text-4xl sm:text-8xl md:text-14xl lg:text-18xl xl:text-20xl font-secondary font-extrabold py-5 md:py-8 px-5 md:px-16">
      <h1 class="text-secondary-700">
      Odkryj wyzwania, które podejmuje
        <span class="text-primary-600">
      leasing z ProcessWay
    </span>
    </h1>

  </div>
  <div class="w-[95%] md:w-[80%] max-w-[1500px] h-auto">
    <div class="flex mb-4 gap-2 justify-end">
      @for (item of faqItems; track $index; let idx = $index) {
        <p-button
          (onClick)="active = idx.toString()"
          [rounded]="true"
          label="{{ (idx + 1).toString() }}"
          styleClass="w-8 h-8 p-fab"
          [outlined]="active !== idx.toString()">
        </p-button>
      }
    </div>
    <div class="shadow-xl" >
      <p-accordion [(value)]="active">
        @for (item of faqItems; track $index; let idx = $index) {

          <p-accordion-panel [value]="idx.toString()">
            <p-accordion-header>
              <span class="font-bold font-secondary text-primary-700 text-xs sm:text-sm md:text-md">
                {{ item.header }}
              </span>
            </p-accordion-header>
            <p-accordion-content>
              <p class="m-0 text-xs sm:text-sm md:text-md">
                {{ item.content }}
              </p>
            </p-accordion-content>
          </p-accordion-panel>
        }
      </p-accordion>
    </div>
  </div>
</section>
